<template>
    <div class="purchase-analysis">
        <OptionCard
                :info="{ title: '费用利润',desc: `${pageParams.startDateTime}~${pageParams.endDateTime}`, label: pageParams.dateLabel}"
                :actions="['refresh']"
                @refresh="refresh"
        >
            <gj-alert border type="warning" show-icon>按日期查询时下面数据不包含仓储费;按月份查询时下面数据包含仓储费</gj-alert>
            <el-row type="flex" :gutter="10" style="margin-top: 8px;">
                <el-col :span="5">
                    <div class="purchase-analysis-percent ">
                        <div class="purchase-analysis-percent__content">
                            <div class="purchase-analysis-percent__content--item">
                                <span class="purchase-analysis-percent__content--item__children purchase-analysis-percent__content--item__title">总收入</span>
                                <span class="purchase-analysis-percent__content--item__children purchase-analysis-percent__content--item__price">{{ currencySymbol }}{{ summaryData.income | amount | defaultShow }}</span>
                                <span class="purchase-analysis-percent__content--item__children" :class="[summaryData.incomeQoq > 0 ? 'up' : 'down']">环比：{{ summaryData.incomeQoq || 0 | abs }}%<gj-icon :class="[summaryData.incomeQoq > 0 ? 'el-icon-top': 'el-icon-bottom']" ></gj-icon></span>
                            </div>
                            <div class="purchase-analysis-percent__content--item">
                                <span class="purchase-analysis-percent__content--item__children purchase-analysis-percent__content--item__title">总支出</span>
                                <span class="purchase-analysis-percent__content--item__children purchase-analysis-percent__content--item__price">{{ currencySymbol }}{{ summaryData.expenses | amount | defaultShow }}</span>
                                <span class="purchase-analysis-percent__content--item__children" :class="[summaryData.expensesQoq > 0 ? 'up' : 'down']">环比：{{ summaryData.expensesQoq || 0 | abs }}%<gj-icon :class="[summaryData.expensesQoq > 0 ? 'el-icon-top': 'el-icon-bottom']" ></gj-icon></span>
                            </div>
                            <div class="purchase-analysis-percent__content--item">
                                <span class="purchase-analysis-percent__content--item__children purchase-analysis-percent__content--item__title">销售净毛利</span>
                                <span class="purchase-analysis-percent__content--item__children purchase-analysis-percent__content--item__price">{{ currencySymbol }}{{ summaryData.grossProfit | amount | defaultShow }}</span>
                                <span class="purchase-analysis-percent__content--item__children" :class="[summaryData.grossProfitQoq > 0 ? 'up' : 'down']">环比：{{ summaryData.grossProfitQoq || 0 | abs }}%<gj-icon :class="[summaryData.grossProfitQoq > 0 ? 'el-icon-top': 'el-icon-bottom']" ></gj-icon></span>
                            </div>
                            <div class="purchase-analysis-percent__content--item">
                                <span class="purchase-analysis-percent__content--item__children purchase-analysis-percent__content--item__title">ROI</span>
                                <span class="purchase-analysis-percent__content--item__children purchase-analysis-percent__content--item__price">{{ summaryData.roi | defaultShow }}%</span>
                                <span class="purchase-analysis-percent__content--item__children" :class="[summaryData.roiQoq > 0 ? 'up' : 'down']">环比：{{ summaryData.roiQoq || 0 | abs }}%<gj-icon :class="[summaryData.roiQoq > 0 ? 'el-icon-top': 'el-icon-bottom']" ></gj-icon></span>
                            </div>
                            <div class="purchase-analysis-percent__content--item">
                                <span class="purchase-analysis-percent__content--item__children purchase-analysis-percent__content--item__title">预计回款</span>
                                <span class="purchase-analysis-percent__content--item__children purchase-analysis-percent__content--item__price">{{ currencySymbol }}{{ summaryData.expectedReturn | amount | defaultShow }}</span>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="19" v-loading="loading.ring">
                    <div class="purchase-analysis-percent-border">
                        <ve-histogram height="300px" :data-empty="ChartBarData.empty" :data="ChartBarData.data" :settings="ChartBarData.settings" :extend="ChartBarData.options"></ve-histogram>
                    </div>
                </el-col>
            </el-row>
            <el-row type="flex" :gutter="10" class="purchase-analysis-percent-margin">
                <el-col :span="12" v-loading="loading.ring">
                    <OptionCard hide-header :actions="['full']" :body-style="{padding: '10px 0 0 0'}">
                        <ve-ring height="300px" :data-empty="ChartOneData.empty" :data="ChartOneData.data" :settings="ChartOneData.settings" :extend="ChartOneData.options"></ve-ring>
                    </OptionCard>
                    </el-col>
                <el-col :span="12" v-loading="loading.ring">
                    <OptionCard hide-header :actions="['full']" :body-style="{padding: '10px 0 0 0'}">
                        <ve-ring height="300px" :data-empty="ChartTwoData.empty" :data="ChartTwoData.data" :settings="ChartTwoData.settings" :extend="ChartTwoData.options"></ve-ring>
                    </OptionCard>
                </el-col>
            </el-row>
        </OptionCard>
    </div>
</template>

<script>
    import { postFeeDetails } from '@/api/statistics'

    import {
        DATA_CHARTS,
        generatorPieOneChartsData,
        generatorPieTwoChartsData,
        generatorBarChartsData
    } from "modules/statistics/asin-361-analysis/config";
    import { settingMapFeeDetails as settingMap } from "@/utils/setting";

    import OptionCard from 'components/option-card/option-card'

    export default {
        name: "statistics-purchase-analysis",
        inject: ['getPageParams', 'generatorPageParams'],
        data () {
          return {
              DATA_CHARTS,
              currency: '',
              currencySymbol: '',
              summaryData: {},
              barData: [],
              pieData: {}, // 饼图源数据
              pieOneOptions: {}, // 饼图配置
              pieTwoOptions: {}, // 饼图配置
              loading: {
                  ring: false
              },
              noData: {
                  ringOne: false,
                  ringTwo: false,
                  bar: false
              }
          }
        },
        components: {
            OptionCard
        },
        created () {
            this.postFeeDetails()
        },
        computed: {
            pageParams() {
                return this.getPageParams()
            },
            ChartOneData ({ pieData, currencySymbol = '' }) {
                let { incomeItems = [], incomeExtraItems = [] } = pieData
                let columns = ['name', 'value', 'averageFee', 'rate']
                let rows = incomeItems.concat(incomeExtraItems).map(({
                      itemName: name = '',
                      averageFee = '',
                      fee: value = '',
                      feePercent: rate = ''
                  }) => {
                    let item

                    if (['Discount cost', 'Ads sales'].includes(name)) {
                        item = {
                            name: settingMap[name] ? settingMap[name] : name,
                            extraValue: value,
                            currencySymbol
                        }
                    } else {
                        item = {
                            name: settingMap[name] ? settingMap[name] : name,
                            value,
                            averageFee,
                            rate,
                            currencySymbol
                        }
                    }
                    return item
                })

                let makeOptions = generatorPieOneChartsData(this.currencySymbol)
                return {
                    data: {
                        columns,
                        rows
                    },
                    settings: {},
                    options: makeOptions(rows),
                    empty: !rows.length
                }
            },
            ChartTwoData ({ pieData, currencySymbol = '' }) {
                let { expensesItems = [] } = pieData
                let columns = ['name', 'value', 'averageFee', 'rate']
                let rows = expensesItems.map(({
                    itemName: name = '',
                    averageFee = '',
                    fee: value = '',
                    feePercent: rate = ''
                }) => ({
                    name: settingMap[name] ? settingMap[name] : name,
                    value,
                    averageFee,
                    rate,
                    currencySymbol
                }))
                let makeOptions = generatorPieTwoChartsData(this.currencySymbol)
                return {
                    data: {
                        columns,
                        rows
                    },
                    settings: {},
                    options: makeOptions(rows),
                    empty: !rows.length
                }

            },
            ChartBarData ({ barData = [] }) {
                let columns = ['marketName', 'income', 'expenses', 'expectedReturn']
                let rows = barData.map(({
                    marketName = '',
                    income = 0,
                    expenses = 0,
                    expectedReturn = 0,
                    incomePercent = 0,
                    expensesPercent = 0,
                    expectedReturnPercent = 0,
                    roi = 0
                }) => ({
                    marketName,
                    income,
                    expenses,
                    expectedReturn,
                    incomePercent,
                    expensesPercent,
                    expectedReturnPercent,
                    roi
                }))



                return {
                    data: {
                        columns,
                        rows
                    },
                    settings: {
                        labelMap: {
                            marketName: '店铺',
                            income: '收入',
                            expenses: '支出',
                            expectedReturn: '预计回款'
                        },
                    },
                    options: generatorBarChartsData(this.currencySymbol),
                    empty: !rows.length
                }
            }
        },
        methods: {
            /**
             * 获取费用明细
             */
            postFeeDetails () {
                let params = this.generatorPageParams(this.pageParams)
                this.loading.ring = true
                postFeeDetails(params).then(({
                     currency = '',
                     currencySymbol = '',
                     summaryData = {},
                     barData = [],
                     pieData = []
                }) => {
                    this.currency = currency
                    this.currencySymbol = currencySymbol
                    this.summaryData = Object.assign({}, this.summaryData, summaryData)
                    this.barData = barData
                    this.pieData = Object.assign({}, this.pieData, pieData)
                }).complete(() => {
                    this.loading.ring = false
                })
            },
            /**
             * 刷新区域数据
             */
            refresh () {
                this.postFeeDetails()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .purchase-analysis-percent {
        color: #666666;
        flex: 1;
        &-margin {
            margin: 15px 0;
        }

        &-border {
            border-radius: 4px;
            border: 1px solid #EBEEF5;
            overflow: hidden;
        }

        &__title {
            padding-top: 7px;
        }

        &__content {
            display: flex;
            flex-wrap: wrap;
            &--item {
                box-sizing: border-box;
                width: 50%;
                padding-left: 20px;
                margin-top: 30px;
                font-size: 0;

                &__title {
                    font-weight: bold;
                    font-size: 14px;
                }

                &__children {
                    font-size: 12px;
                    margin-top: 5px;
                    display: inline-block;
                    width: 100%;

                    &.up {
                        color: #19BE6B;
                    }

                    &.down {
                        color: #F56C6C;
                    }
                }

                & > &__price {
                    font-size: 14px;
                    font-weight: bold;

                }
            }
        }
    }
</style>
